module.exports = __webpack_public_path__ + "img/fourday_ps_09.edf7c896.jpg";